// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Citation } from "./Citation";
import {
  CitationFromJSON,
  CitationFromJSONTyped,
  CitationToJSON,
  CitationToJSONTyped,
} from "./Citation";

/**
 *
 * @export
 * @interface QualityReport
 */
export interface QualityReport {
  /**
   * Naam en datum van de specificatie (bijv. INSPIRE Data Specification).
   */
  specification: Citation;
  /**
   * Uitleg van de betekenis van de conformiteit.
   */
  explanation: string | null;
  /**
   * Geeft aan of de dataset voldoet aan de eisen van de specificatie.
   */
  conforms: boolean;
}

/**
 * Check if a given object implements the QualityReport interface.
 */
export function instanceOfQualityReport(value: object): value is QualityReport {
  if (!("specification" in value) || value["specification"] === undefined) return false;
  if (!("explanation" in value) || value["explanation"] === undefined) return false;
  if (!("conforms" in value) || value["conforms"] === undefined) return false;
  return true;
}

export function QualityReportFromJSON(json: any): QualityReport {
  return QualityReportFromJSONTyped(json, false);
}

export function QualityReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): QualityReport {
  if (json == null) {
    return json;
  }
  return {
    specification: CitationFromJSON(json["specification"]),
    explanation: json["explanation"],
    conforms: json["conforms"],
  };
}

export function QualityReportToJSON(json: any): QualityReport {
  return QualityReportToJSONTyped(json, false);
}

export function QualityReportToJSONTyped(
  value?: QualityReport | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    specification: CitationToJSON(value["specification"]),
    explanation: value["explanation"],
    conforms: value["conforms"],
  };
}
